<!-- eslint-disable -->
<template>
  <CommonPages id="home" :class="['home']" titlePrefix="Home">
    <HomeBanner />
    <AdComponent :key="'ads-home-1'" v-if="deviceType != 'mobile' "
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_1" ref="ads-home-1"
      class="ad-width-100 pc_padding" :ads="adsensConfig?.home_1" :showDebug="showDebug" />
    <AdComponent :key="'ads-home-1'" v-if="deviceType == 'mobile' "
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_1" ref="ads-home-1"
      class="ad-width-100 m_padding" :ads="adsensConfig?.home_1" :showDebug="showDebug" />
    <HomeNameWeek />
    <AdComponent :key="'ads-home-2'" v-if="deviceType == 'mobile' "
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_2" ref="ads-home-2"
      class="ad-width-100 m_padding" :ads="adsensConfig?.home_2" :showDebug="showDebug" />
    <HomeSearch />
    <AdComponent :key="'ads-home-3'" v-if="deviceType != 'mobile' "
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_3" ref="ads-home-3"
      class="ad-width-100 pc_padding" :ads="adsensConfig?.home_3" :showDebug="showDebug" />
    <AdComponent :key="'ads-home-3'" v-if="deviceType == 'mobile' "
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_3" ref="ads-home-3"
      class="ad-width-100 m_padding" :ads="adsensConfig?.home_3" :showDebug="showDebug" />
    <HomePreview />
    <AdComponent :key="'ads-home-4'" v-if="deviceType == 'mobile' "
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_4" ref="ads-home-4"
      class="ad-width-100 m_padding" :ads="adsensConfig?.home_4" :showDebug="showDebug" />
    <HomeCategory />
    <HomeData />
    <HomeBlogger />
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import HomeBanner from '@/components/HomeBanner.vue'
import HomeNameWeek from '@/components/HomeNameWeek.vue'
import HomeSearch from '@/components/HomeSearch.vue'
import HomePreview from '@/components/HomePreview.vue'
import HomeCategory from '@/components/HomeCategory.vue'
import HomeData from '@/components/HomeData.vue'
import HomeBlogger from '@/components/HomeBlogger.vue'
import AdComponent from '@/pages/components/AdComponent.vue'
import '@/css/home.scss';
import '@/css/common.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
    HomeBanner,
    HomeNameWeek,
    HomeSearch,
    HomePreview,
    HomeCategory,
    HomeData,
    HomeBlogger,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {

    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
      'showDebug',
    ]),
    pageTitle () {
      const origin = this.domainConfig?.origin || '';
      return `Discover Beautiful ${origin} Names`;
    },
    pageDescription () {
      const origin = this.domainConfig?.origin || '';
      return `Instantly generate beautiful and meaningful ${origin} names with our AI-powered tool. Explore traditional, modern, and gender-neutral options.`;
    }
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component activated`);
    }

  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component mounted`);
    }
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

